var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 61,
    viewBox: "0 0 86 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0886 59.8264C54.8024 59.8264 54.5151 59.8117 54.229 59.7959C53.3999 59.7359 52.7654 59.012 52.8265 58.1819C52.8864 57.3528 53.6103 56.7489 54.4405 56.7794C57.0645 56.9604 59.6297 56.0103 61.4845 54.1554C63.2037 52.4509 64.139 50.173 64.139 47.7594C64.139 45.3458 63.2037 43.069 61.4845 41.3645C59.7642 39.66 57.5021 38.7099 55.0885 38.7099H9.83788C9.0088 38.7099 8.3291 38.0313 8.3291 37.2012C8.3291 36.3721 9.00772 35.6924 9.83788 35.6924H55.0885C58.3164 35.6924 61.3476 36.9444 63.6255 39.2222C65.9034 41.5001 67.1553 44.5313 67.1553 47.7592C67.1553 50.9871 65.9033 54.0183 63.6255 56.2962C61.3487 58.5594 58.2711 59.826 55.0885 59.826L55.0886 59.8264Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6487 31.1693H2.29785C1.46876 31.1693 0.789062 30.4907 0.789062 29.6606C0.789062 28.8315 1.46769 28.1518 2.29785 28.1518H65.6487C72.3003 28.1518 77.7158 22.7365 77.7158 16.0847C77.7158 9.4331 72.3006 4.01757 65.6487 4.01757C64.8196 4.01757 64.1399 3.33895 64.1399 2.50879C64.1399 1.6797 64.8186 1 65.6487 1C73.9595 1 80.7323 7.77278 80.7323 16.0835C80.7323 24.3965 73.9606 31.1692 65.6487 31.1692V31.1693Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.744 22.1195C37.744 23.3695 36.7308 24.3816 35.4809 24.3816C34.232 24.3816 33.2188 23.3695 33.2188 22.1195C33.2188 20.8696 34.232 19.8574 35.4809 19.8574C36.7308 19.8574 37.744 20.8696 37.744 22.1195Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.744 22.1195C37.744 23.3695 36.7308 24.3816 35.4809 24.3816C34.232 24.3816 33.2188 23.3695 33.2188 22.1195C33.2188 20.8696 34.232 19.8574 35.4809 19.8574C36.7308 19.8574 37.744 20.8696 37.744 22.1195",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3172 23.6284C51.3172 24.8773 50.304 25.8905 49.0551 25.8905C47.8052 25.8905 46.792 24.8773 46.792 23.6284C46.792 22.3784 47.8052 21.3652 49.0551 21.3652C50.304 21.3652 51.3172 22.3784 51.3172 23.6284Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3846 19.104C63.3846 20.3529 62.3714 21.3661 61.1225 21.3661C59.8726 21.3661 58.8594 20.3529 58.8594 19.104C58.8594 17.854 59.8726 16.8408 61.1225 16.8408C62.3714 16.8408 63.3846 17.854 63.3846 19.104Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7107 44.7455C31.7107 45.9954 30.6986 47.0076 29.4486 47.0076C28.1987 47.0076 27.1865 45.9954 27.1865 44.7455C27.1865 43.4956 28.1987 42.4834 29.4486 42.4834C30.6986 42.4834 31.7107 43.4956 31.7107 44.7455Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2684 46.2534C42.2684 47.5023 41.2552 48.5155 40.0053 48.5155C38.7564 48.5155 37.7432 47.5023 37.7432 46.2534C37.7432 45.0034 38.7564 43.9902 40.0053 43.9902C41.2552 43.9902 42.2684 45.0034 42.2684 46.2534Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3357 47.7631C54.3357 49.013 53.3236 50.0262 52.0736 50.0262C50.8237 50.0262 49.8115 49.013 49.8115 47.7631C49.8115 46.5142 50.8237 45.501 52.0736 45.501C53.3236 45.501 54.3357 46.5142 54.3357 47.7631Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9597 47.7631C76.9597 49.013 75.9476 50.0262 74.6976 50.0262C73.4477 50.0262 72.4355 49.013 72.4355 47.7631C72.4355 46.5142 73.4477 45.501 74.6976 45.501C75.9476 45.501 76.9597 46.5142 76.9597 47.7631Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2333 53.7944C36.2333 55.0433 35.2201 56.0565 33.9712 56.0565C32.7212 56.0565 31.708 55.0433 31.708 53.7944C31.708 52.5445 32.7212 51.5312 33.9712 51.5312C35.2201 51.5312 36.2333 52.5445 36.2333 53.7944Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9413 37.2045C73.9413 38.4544 72.9281 39.4666 71.6792 39.4666C70.4292 39.4666 69.416 38.4544 69.416 37.2045C69.416 35.9545 70.4292 34.9424 71.6792 34.9424C72.9281 34.9424 73.9413 35.9545 73.9413 37.2045Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5037 35.6947C84.5037 36.9447 83.4915 37.9579 82.2416 37.9579C80.9916 37.9579 79.9795 36.9447 79.9795 35.6947C79.9795 34.4458 80.9916 33.4326 82.2416 33.4326C83.4915 33.4326 84.5037 34.4458 84.5037 35.6947Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8446 11.5639C55.8446 12.8128 54.8314 13.826 53.5825 13.826C52.3325 13.826 51.3193 12.8128 51.3193 11.5639C51.3193 10.314 52.3325 9.30078 53.5825 9.30078C54.8314 9.30078 55.8446 10.314 55.8446 11.5639Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7947 16.0864C46.7947 17.3353 45.7825 18.3485 44.5326 18.3485C43.2827 18.3485 42.2705 17.3353 42.2705 16.0864C42.2705 14.8365 43.2827 13.8232 44.5326 13.8232C45.7825 13.8232 46.7947 14.8365 46.7947 16.0864Z",
    fill: "#FF5910",
    stroke: "#FF5910",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirQuality);
export default __webpack_public_path__ + "static/media/airQuality.cb77726aa36855bcbaa2de82c88d55c7.svg";
export { ForwardRef as ReactComponent };